import { Component, Inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'iho-plp-refresh-alert',
  standalone: true,
  imports: [MatRippleModule, MatDialogModule, RouterLink, NgIf],
  templateUrl: './plp-refresh-alert.component.html',
  styleUrls: ['./plp-refresh-alert.component.scss'],
})
export class PlpRefreshAlertComponent {
  pageType = 'جستجو'

  constructor(@Inject(MAT_DIALOG_DATA) data: { pageType: string }) {
    this.pageType = data.pageType ?? 'plp'
  }
}
